import { createQuery } from '@luna/api';

import { fetchCurrencies } from './CurrenciesApiService';

const currenciesQuery = createQuery({
    name: 'payments/currencies',
    payloadCreator: fetchCurrencies,
});

export const [
    useCurrenciesQuery,
    { queryApiIfNeeded: fetchCurrenciesIfNeeded, selectData: selectCurrencies },
] = currenciesQuery;
